import { Link, useParams } from "react-router-dom";
import { usePublication } from "../../../hooks/usePublication";
import { useEffect, useState } from "react";
import { findTypeOption, typeLibro } from "../../../interfaces/Publication";
import { Portal } from "../RightMenu/Portal";
import CalificaTuExperiencia from "../RightMenu/ModalCalificacion";
import { useUser } from "../../../hooks";

const Pager = () => {
  const { publication, changePublication } = usePublication();
  const { user } = useUser();
  
  const [percent, setPercent] = useState(100);
  const [showCalificacion, setShowCalificacion] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const [shouldShowModal, setShouldShowModal] = useState(false);

  let { idRevista, idLibro } = useParams();
  const typeLibro: typeLibro = idLibro ? "libro" : "revista";
  const route = findTypeOption(typeLibro)?.route || "";

  const handleCloseCalificacion = () => {
    setShowCalificacion(false);
    setShouldShowModal(false);
  };

  const handleCloseNotification = () => {
    setShowNotification(false);
  };

  // Effect para el scroll
  useEffect(() => {
    const content = document.getElementById("mainContent");
    if (!content) return;

    const handleScroll = () => {
      const scrollHeight = content.scrollHeight - content.clientHeight;
      const scrollY = content.scrollTop;
      const percentCurrent = (scrollY * 100) / scrollHeight;
      setPercent(100 - percentCurrent);
    };

    content.addEventListener("scroll", handleScroll);
    
    return () => {
      content.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const checkIfUserHasRated = async (): Promise<boolean> => {
    if (!user) return false;
    
    try {
      const response = await fetch(
        `https://apivirtualplant.com/apiVpro/public/api/getValoracionUnity?fvu_id_recurso=${idRevista || idLibro}&fvu_email=${user.sus_email}`
      );
      
      if (!response.ok) {
        throw new Error(`Error en la respuesta: ${response.status}`);
      }
      
      const data = await response.json();
      return Array.isArray(data) && data.length > 0;
    } catch (error) {
      console.error("Error al verificar calificación:", error);
      return false;
    }
  };

  const updateSection = (numberSection: number) => {
    let tmpPublication = publication;
    tmpPublication.currentSection = numberSection;
    changePublication(tmpPublication);
  };

  // Effect para mostrar el modal después de navegar
  useEffect(() => {
    const showModalIfNeeded = async () => {
      // Solo mostrar si llegamos al último capítulo Y el usuario pidió verlo
      if (shouldShowModal && publication.currentSection + 1 === publication.sections.length) {
        const userHasRated = await checkIfUserHasRated();
        
        if (!userHasRated) {
          console.log("Abriendo modal de calificación...");
          setShowCalificacion(true);
        }
        // Resetear la bandera
        setShouldShowModal(false);
      }
    };

    showModalIfNeeded();
  }, [publication.currentSection, shouldShowModal]);

  const handleNextClick = async (e: React.MouseEvent) => {
    // Solo verificar si el próximo capítulo es el último
    if (publication.currentSection + 2 === publication.sections.length) {
      setShouldShowModal(true);
    }
  };

  return (
    <div className="pager">
      <div className="pager__item" style={{ zIndex: 1 }}>
        <Link
          to={
            publication.currentSection
              ? `/${route}/${publication.id}/${publication.currentSection - 1}`
              : "#"
          }
          type="button"
          className={`pager__btn tippy ${
            publication.currentSection <= 0 ? "disabled" : ""
          }`}
          data-tippy-content="Capítulo anterior"
        >
          <i className="icon icon-vpro-chevron-left"></i>
        </Link>
      </div>

      <div className="pager__item">
        <div className="prog-indicator">
          <svg
            viewBox="0 0 110 110"
            xmlns="http://www.w3.org/2000/svg"
            style={{ width: "180px" }}
          >
            <circle
              id="pb"
              cx="55"
              cy="55"
              r="14"
              fill="transparent"
            ></circle>
            <circle
              id="p"
              cx="55"
              cy="55"
              r="14"
              fill="transparent"
              style={{
                strokeDasharray: "100, 100",
                strokeDashoffset: `${percent}`,
                visibility: "visible",
              }}
            ></circle>
          </svg>
        </div>
        <input
          type="number"
          min={1}
          max={publication.sections.length}
          value={(publication.currentSection + 1).toString()}
          style={{ appearance: "textfield" }}
          id="chapter"
          className="prog-indicator__current tippy"
          aria-label="página actual"
          pattern="[0-9]+"
          title="Ingrese solo números"
          onChange={(e) => updateSection(parseInt(e.target.value) - 1)}
        />
      </div>

      <div className="pager__item">
        <Link
          to={
            publication.sections.length - 1 > publication.currentSection
              ? `/${route}/${publication.id}/${publication.currentSection + 1}`
              : "#"
          }
          type="button"
          className={`pager__btn tippy ${
            publication.currentSection + 1 === publication.sections.length ? "disabled" : ""
          }`}
          onClick={handleNextClick}
        >
          <i className="icon icon-vpro-chevron-right"></i>
        </Link>
      </div>

      {showCalificacion && (
        <Portal>
          <CalificaTuExperiencia
            onClose={handleCloseCalificacion}
            setShowNotification={setShowNotification}
          />
        </Portal>
      )}

    </div>
  );
};

export default Pager;